import {NgModule} from '@angular/core';
import {
  ActivationStart,
  NavigationStart,
  Router,
  RouterModule
} from '@angular/router';
import {CustomPreloader} from '@app/customPreloader';
import {appRoutes} from '@app/routes';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {environment} from 'environments/environment';

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: environment.enableRouteTracing,
      useHash: true,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'disabled',
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: CustomPreloader
    }),
    StoreRouterConnectingModule.forRoot()
  ],
  exports: [RouterModule],
  providers: [CustomPreloader]
})
export class AppRoutingModule {
  constructor(router: Router) {
    router.events.subscribe(e => {
      if (environment.enableRouteTracing === true) {
        if (e instanceof NavigationStart) {
          this.onRouterChangeStart(e);
        } else if (e instanceof ActivationStart) {
          this.onActivationStart(e);
        }
      }
    });
  }

  onRouterChangeStart(e: NavigationStart) {
    console.log(e);
  }

  onActivationStart(e: ActivationStart) {
    console.log(e);
  }
}
